import { render, staticRenderFns } from "./NoticeMain.vue?vue&type=template&id=8f5aeb76&"
import script from "./NoticeMain.vue?vue&type=script&lang=js&"
export * from "./NoticeMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports